import axios from 'axios';
import Head from 'next/head';
import dynamic from 'next/dynamic';
import React, { useState, useEffect, useRef } from 'react';
import LazyLoad, { lazyload, forceCheck } from 'react-lazyload';

import Thanks from '../../components/Thanks';
import Includings from '../../components/Base/Includeing';
import PPCPlansSLider from '../../components/sliders/PPCPlansSLider';
import VideoReviewsSlider from '../../components/sliders/VideoReviewsSlider';
import PPCManagementSLider from '../../components/sliders/ppcManagementServiceSlider';
import AdditionalPPCSlider from '../../components/sliders/AdditionalPPCSLider';
import SimpleSlider from '../../components/ppc/ProcessSlider';
import SchedulaACall from '../../components/Base/SchedulaACall';

const Faq = dynamic(() => import('../../components/Faq'));
const ViewMore = dynamic(() => import('../../components/ViewMore'));
const ViewMorePPC = dynamic(() => import('../../components/ViewMorePPC'));
const GetProposal = dynamic(() => import('../../components/proposal/ppc/GetProposal'));
const GetOrderProposal = dynamic(() => import('../../components/proposal/ppc/OrderNow'));
const GetCustomProposal = dynamic(() => import('../../components/proposal/ppc/GetCustomProposal'));

const Content = dynamic(() => import('./parts/paid'));

lazyload({
  width: '100%',
});
const PaidAdvertiseingServices = props => {
  const url = 'https://admin.weprodigi.com/api/get-ppc';
  const [showOfferModal, setShowOfferModal] = useState(false);
  const [showOrderModel, setShowOrderModel] = useState(false);
  const [showCostumProposalModel, setShowCostumProposalModel] = useState(false);
  const [ppc, setPPC] = useState([]);
  const [website, setWebsite] = useState('');
  const [service, setService] = useState('');
  const [totalFirstPlan, setTotalFirstPlan] = useState(0);
  const [totalSecondPlan, setTotalSecondPlan] = useState(0);
  const [totalThirdPlan, setTotalThirdPlan] = useState(0);
  const [total4, setTotal4] = useState(0);
  const [showThanks, setSHowThanks] = useState(false);
  const [loadedThanks, setLoadedThanks] = useState(false);
  const [name, setName] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [webiste2, setWebsite2] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  const paidRef = useRef(null);

  const [paidPr, setPaidPr] = useState(0);
  const [showFull, setShowFull] = useState(false);
  const hideOrderModal = () => {
    setShowOrderModel(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflow = 'auto';
  };
  const hideOfferModal = () => {
    setShowOfferModal(false);
    setWebsite('');
    document.querySelector('[name=website]').value = '';
    document.getElementById('web2').value = '';
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflow = 'auto';
  };
  const hideCostumProposalModal = () => {
    setShowCostumProposalModel(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflow = 'auto';
  };
  const hideThanksModal = () => {
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflow = 'auto';
    setSHowThanks(false);
    setLoadedThanks(false);
    setName('');
    setCompanyName('');
    setEmail('');
    setWebsite2('');
    setPhone('');
  };
  const onSubmit = e => {
    e.preventDefault();
    let form_data = new FormData();

    form_data.append('country', props.country);
    form_data.append('name', name);
    form_data.append('company-name', companyName);
    form_data.append('website', webiste2);
    form_data.append('email', email);
    form_data.append('phone-number', phone);
    form_data.append('service', 'Paid Ads Audit');
    document.getElementById('name').value = '';
    document.getElementById('email').value = '';
    document.getElementById('company_name').value = '';
    document.getElementById('website').value = '';
    document.getElementById('phone-number').value = '';
    // setSHowThanks(true)
    document.body.style.overflow = 'hidden';
    axios.post('https://mailer.weprodigi.com/api/v1/order-now', form_data).then(response => {
      // setLoadedThanks(true)
      window.location.href = 'https://weprodigi.com/thank-you';
    });
  };
  const formTotalPrice = () => {
    const c = props.currency.toString();
    if (c == 'amd' || c == 'AMD' || c == 'usd') {
      setTotalFirstPlan('$3000-$10.000');
      setTotalSecondPlan('$10.001-$40.000');
      setTotalThirdPlan('$40.001+');
      setTotal4('$800');
      setPaidPr('$3000');
    }
    if (c == 'eur') {
      setTotalFirstPlan('€3000-€10.000');
      setTotalSecondPlan('€10.001-€40.000');
      setTotalThirdPlan('€40.001+');
      setTotal4('€700');
      setPaidPr('€3000');
    }
    if (c == 'gbp') {
      setTotalFirstPlan('£2500-£9000');
      setTotalSecondPlan('£9001-£34.000');
      setTotalThirdPlan('£34.001+');
      setTotal4('£600');
      setPaidPr('£3000');
    }
    if (c == 'aud' || c == 'AUD') {
      setTotalFirstPlan('A$4500-A$14.500');
      setTotalSecondPlan('A$14.501-A$58.000');
      setTotalThirdPlan('AU $58.001+');
      setTotal4('AU $1150');
      setPaidPr('AU $3000');
    }
    if (c == 'rub') {
      setTotalFirstPlan('₽180.000-₽600.000');
      setTotalSecondPlan('₽600.001-₽2.400000');
      setTotalThirdPlan('₽2.400001+');
      setTotal4('₽61000');
      setPaidPr('₽230000');
    }

    if (c == 'sgd') {
      setTotalFirstPlan('SG $700-SG $14.000');
      setTotalSecondPlan('SG $14.001-SG $54.000');
      setTotalThirdPlan('SG $54.001+');
      setTotal4('SG $1100');
      setPaidPr('SG $4500');
    }
    if (c == 'cad') {
      setTotalFirstPlan('C$4200-C$13.000');
      setTotalSecondPlan('C$13.001-C$52.000');
      setTotalThirdPlan('CA $52.001+');
      setTotal4('CA $1100');
      setPaidPr('CA $4000');
    }
    if (c == 'nzd') {
      setTotalFirstPlan('N$4900-N$16.100');
      setTotalSecondPlan('N$16.101-N$64.300');
      setTotalThirdPlan('N$64.301+');
      setTotal4('NZ $1250');
      setPaidPr('NZ $4900');
    }

    // toDo total4 and paidPr

    if (c == 'ae') {
      setTotalFirstPlan('11.010AED - 36.720AED');
      setTotalSecondPlan('36.720AED - 146.910AED');
      setTotalThirdPlan('146.910AED+');
    }
    if (c == 'qa') {
      setTotalFirstPlan('10.940QAR - 36.460QAR');
      setTotalSecondPlan('36.460QAR - 145.820QAR');
      setTotalThirdPlan('145.820QAR+');
    }
    if (c == 'sa') {
      setTotalFirstPlan('11.250SR - 37.500SR');
      setTotalSecondPlan('37.500SR - 150.000SR');
      setTotalThirdPlan('150.000SR+');
    }
    if (c == 'kd') {
      setTotalFirstPlan('920KWD - 3080KWD');
      setTotalSecondPlan('3080KWD - 12.300KWD');
      setTotalThirdPlan('12.300KWD+');
    }
  };
  useEffect(() => {
    forceCheck();
    axios
      .get(url)
      .then(function (response) {
        if (response.data.success) setPPC(response.data.ppc);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  const scrollTo = ref => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  useEffect(() => {
    formTotalPrice();
  }, [props.currency]);
  return (
    <>
      <Head>
        <title>Grow Your Revenue with Our PPC Services - Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/paid-advertising-services" />
        <meta
          name="description"
          content="Prodigi helps businesses increase their revenue through Paid Advertising Services on Google, Youtube, Facebook, Instagram, Bing, Yahoo and etc."
        />
        <meta property="og:url" content="https://weprodigi.com/paid-advertising-services" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Grow Your Revenue with Our PPC Services - Prodigi" />
        <meta
          property="og:description"
          content="Prodigi helps businesses increase their revenue through Paid Advertising Services on Google, Youtube, Facebook, Instagram, Bing, Yahoo and etc."
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/ppc/paid-ads.png" />
      </Head>
      <style>
        {`
                        @-webkit-keyframes floater2 {
                          0%{transform: translateY(-80%);transition: ease 0.5s;}
                          50%{transform: translateY(80%);transition: ease 0.5s;}
                        }
                        @keyframes floater2 {
                          0%{transform: translateY(-80%);transition: ease 0.5s;}
                          50%{transform: translateY(80%);transition: ease 0.5s;}
                        }
                        @-webkit-keyframes floater1 {
                          0%{transform: translateY(-75%);transition: ease 0.5s;}
                          50%{transform: translateY(75%);transition: ease 0.5s;}
                        }
                        @keyframes floater1 {
                          0%{transform: translateY(-75%);transition: ease 0.5s;}
                          50%{transform: translateY(75%);transition: ease 0.5s;}
                        }
                         @-webkit-keyframes floater3 {
                          0%{transform: translateY(75%);transition: ease 0.5s;}
                          50%{transform: translateY(-75%);transition: ease 0.5s;}
                        }
                        @keyframes floater3 {
                          0%{transform: translateY(75%);transition: ease 0.5s;}
                          50%{transform: translateY(-75%);transition: ease 0.5s;}
                        }
                         .coin3{
                               transform: translateY(75%);
                               -webkit-transform: translateY(75%);
                              -webkit-animation: floater3 1.8s infinite;
                               animation: floater3 1.8s infinite;
                               -webkit-transition: ease 0.5s;
                              transition: ease 0.5s;
                               animation-delay:0.1s;
                              z-index:2
                        }
                        .coin1{
                              transform: translateY(-75%);
                               -webkit-transform: translateY(-75%); 
                              -webkit-animation: floater1 1.8s infinite;
                               -webkit-transition: ease 0.5s;
                                animation-delay:0.1s;
                              transition: ease 0.5s;
                              // box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px 0px, rgba(0, 0, 0, 0.22) 0px 15px 12px 0px;                
                         }
                         .coin2{
                              transform: translateY(-80%);
                               -webkit-transform: translateY(-80%);
                              -webkit-animation: floater2 1.8s infinite;
                              animation: floater2 1.8s infinite;
                              animation-delay:0.3s;
                              transition: ease 0.5s;
                               -webkit-transition: ease 0.5s;
                              // box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px 0px, rgba(0, 0, 0, 0.22) 0px 15px 12px 0px;              
                            }
                            @media screen and (max-width:1400px){
                                .coin1,.coin2,.coin3{
                                    width:25px
                                }
                                 .coin3{
                                 width:35px;
                                }
                            }
                              @media screen and (max-width:1000px){
                                .coin1,.coin2,.coin3{
                                    width:20px
                                }
                            }
                             @media screen and (max-width:767px){
                                .coin1,.coin2{
                                    width:40px;
                                }
                             .coin3{
                                 width:45px;
                                }
                                .coin1{
                                    right:17%
                                }
                                .coin2{
                                    right:20%
                                }
                            }
                            @media screen and (max-width:578px){
                                .coin1,.coin2{
                                    width:30px;
                                }
                                .coin3{
                                 width:45px;
                                }
                                .coin1{
                                    right:15%
                                }
                                .coin2{
                                    right:17%
                                }
                            }
                            @media screen and (max-width:420px){
                                .coin1,.coin2{
                                    width:25px;
                                }
                                .coin3{
                                 width:35px;
                                }
                                .coin1{
                                    right:15%
                                }
                                .coin2{
                                    right:17%
                                }
                            }
                    `}
      </style>
      <div className="intro relative w-full h-800 md:h-600   bg-gray-light bg-grid MontserratArm">
        <div className="relative  h-800 md:h-600 md:flex md:items-center py-12p">
          <div className="container">
            <div className="relative z-10 flex flex-col flex-wrap justify-center items-start h-3/6 md:pb-90 md:mb-120 lg:mb-0 lg:pb-90">
              <h1 className="text-black md:text-black uppercase md:capitalize font-black md:font-bold text-30 md:text-60 leading-none">
                Paid Advertising <br /> Services
              </h1>
              <p className={'text-purple text-20 md:text-24 leading-29 mt-15 md:mt-16'}>that drive more leads. We guarantee results</p>
              <button
                className={'hidden md:flex items-center cursor-pointer  py-8 bg-green-badge hover:bg-green-hover text-white px-20 rounded-5 mt-24'}
                onClick={() => {
                  setService('Paid Advertising Services');
                  document.documentElement.style.overflow = 'hidden';
                  setShowOrderModel(true);
                }}
              >
                Tell More, Get More
                <img
                  src="https://admin.weprodigi.com//uploads/files/shares/ppc/header-button.svg"
                  className={'ml-15'}
                  width={23}
                  alt="header-button"
                />
              </button>
            </div>
          </div>
          <div className="absolute w-full h-full top-auto left-0 bottom-0">
            <div className="ruller absolute left-0 bottom-0 z-10" />
            <div className="ruller ruller2 hidden md:block absolute left-auto top-0" />
            <div className="overlay absolute w-full md:w-1/3 h-480 md:h-full top-auto bottom-0 left-auto right-0 bg-purple">
              <div className="personage-container">
                <div className="personage relatove md:absolute w-100p  left-0 md:-left-200 md:w-4/5 lg:w-full h-auto bottom-0 md:right-0  ">
                  <img
                    className={'absolute left-15p top-30p z-2 coin3'}
                    src="https://admin.weprodigi.com//uploads/files/shares/ppc/Google_logo.webp"
                    alt="coin"
                    width={'50px'}
                  />
                  <img
                    className={'absolute right-13p top-30p z-2 coin1'}
                    src="https://admin.weprodigi.com//uploads/files/shares/ppc/coin1.webp"
                    alt="coin"
                    width={'40px'}
                  />
                  <img
                    className={'absolute right-17p top-30p z-1 coin2'}
                    src="https://admin.weprodigi.com//uploads/files/shares/ppc/coin2.webp"
                    alt="coin"
                    width={'40px'}
                  />
                  <img width="565" height="557" className="mx-auto" src="/images/dif/paid_main_image-7.webp" alt={'personage'} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LazyLoad height={300} once>
        <div className="bg-white py-30">
          <div className="container">
            <div className="flex flex-wrap justify-between">
              <div className={'cursor-pointer w-full mb-30'}>
                <a
                  href={'/paid-advertising-services/order-now?service=Paid Ads Services'}
                  className=" flex md:hidden items-center justify-center  border rounded-5 border-purple text-center text-18 text-purple px-23 py-5    transition-all icon-calculator-container transition-400"
                >
                  <img src="https://admin.weprodigi.com//uploads/files/shares/ppc/header_mobile_button.svg" width={23} alt="header_mobile_button" />
                  <span className={'ml-10'}>Tell More, Get More</span>
                </a>
                <a
                  href={'/proposals/voice-proposal'}
                  className=" mt-15 flex md:hidden items-center justify-center  border rounded-5 border-green-badge text-center text-18 text-green-badge px-23 py-5 hover:bg-green-badge hover:text-white transition-all icon-calculator-container transition-400"
                >
                  <svg width="15" height="23" viewBox="0 0 15 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_13026_9392)">
                      <path
                        d="M8.22446 0C8.70859 0.177107 9.22993 0.29051 9.67051 0.542165C11.156 1.39336 11.9042 2.71399 11.9179 4.41322C11.9383 7.03007 11.9315 9.64738 11.9206 12.2642C11.912 14.4089 10.563 16.1005 8.4722 16.6228C6.27113 17.1731 3.82369 15.7391 3.26197 13.5505C3.14958 13.1152 3.09032 12.668 3.08546 12.2186C3.06913 9.63156 3.06051 7.04453 3.08274 4.45795C3.09908 2.55812 3.98114 1.16837 5.70941 0.346534C6.04381 0.187047 6.42041 0.114758 6.7775 0.00225902L8.22446 0Z"
                        fill="currentColor"
                      />
                      <path
                        d="M6.80159 21.6234V19.789C6.44405 19.7208 6.09376 19.6743 5.75437 19.5853C2.99476 18.8619 1.18527 17.1288 0.306383 14.4324C0.0908588 13.7733 0.0110016 13.087 0.00011198 12.3939C-0.0062403 11.9846 0.258287 11.6805 0.63534 11.6557C1.03236 11.6294 1.31866 11.8852 1.37629 12.3085C1.45161 12.8633 1.47656 13.4326 1.62221 13.9693C2.07867 15.6464 3.1032 16.9119 4.64317 17.713C6.47445 18.6658 8.3638 18.7038 10.2168 17.7808C12.1166 16.8347 13.221 15.2741 13.555 13.1827C13.6058 12.8665 13.6003 12.5403 13.6457 12.2213C13.6675 12.0636 13.746 11.9192 13.8667 11.8148C13.9873 11.7104 14.142 11.6532 14.3018 11.6538C14.3944 11.6509 14.4865 11.6668 14.5727 11.7006C14.6588 11.7344 14.7372 11.7853 14.8029 11.8503C14.8686 11.9153 14.9203 11.9929 14.9548 12.0784C14.9894 12.164 15.006 12.2556 15.0037 12.3478C14.9915 13.5677 14.7224 14.727 14.1416 15.8028C13.1534 17.6317 11.657 18.8624 9.66647 19.4804C9.19594 19.6264 8.70228 19.6969 8.20363 19.8057V21.6066C8.28348 21.6121 8.36198 21.6225 8.44093 21.6225C9.16373 21.6225 9.88698 21.6225 10.6098 21.6256C10.7448 21.6225 10.8795 21.6409 11.0086 21.6803C11.3085 21.7837 11.4814 22.0996 11.4356 22.4181C11.4117 22.568 11.3384 22.7058 11.2273 22.8098C11.1162 22.9137 10.9735 22.978 10.8217 22.9923C10.7023 23.0041 10.5807 22.9986 10.4587 22.9986C8.41779 22.9986 6.37689 22.9986 4.336 22.9986C3.84642 22.9986 3.53924 22.7023 3.56465 22.2622C3.58597 21.8836 3.87909 21.6297 4.32375 21.6256C5.05426 21.6193 5.78477 21.6256 6.51528 21.6256L6.80159 21.6234Z"
                        fill="currentColor"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_13026_9392">
                        <rect width="15" height="23" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <span className={'ml-10'}>Send a Voice Message</span>
                </a>
              </div>
              <p className="w-full md:w-half-auto mb-0 md:mb-0">
                With the technologies rapidly advancing, advertisements are no longer bound to billboards, newspapers, TV, or radio. Paid ads, run
                through the digital channels (Google, Bing, YouTube, etc.), are the top proven tactics that can be in the digital arsenal of a
                business. If designed effectively and targeted, your ad campaign can help you reach consumers in every stage of the buying funnel and
                transform warm leads into payable customers. To make sure you have a substantial return on investments and your efforts are
                measurable, the digital service provider should be trusted with years of relevant experience and background. At ProDigi, we have
                implemented a deep research strategy and run successful marketing campaigns in over 25 industries (including eCommerce, healthcare,
                financial technologies, etc.). We will clearly define your business needs and nuances with an extensive background to better address
                your target audience bottlenecks with effective paid ads. Your success is guaranteed and proved by more than 135 success stories we
                are ready to share with you.
              </p>
              <div className="w-full md:w-half-auto hidden md:block">
                <img
                  className="mx-auto md:mx-0"
                  alt="main"
                  src="https://admin.weprodigi.com/uploads/files/shares/ppc/WhatisPaidAdvertising2.webp"
                  width={539}
                  height={302}
                />
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>
      <div className={`bg-gray-light`}>
        <div className={`image-left-block py-30 container`}>
          <h2 className={'text-purple mb-15 text-24 md:text-36 font-black uppercase'}>Paid Advertising Service Plans</h2>
          <PPCPlansSLider total1={totalFirstPlan} total2={totalSecondPlan} total3={totalThirdPlan} total4={total4} />
        </div>
      </div>
      <div className="bg-white py-23 pb-0 md:pb-23 relative" id={'paid-ads'}>
        <div className="container">
          <div className="grid grid-cols-12">
            <div className="col-span-12 md:col-span-6">
              <h2 className="text-purple text-24 md:text-48 font-black uppercase pb-14 md:mb-23 leading-tight">paid ads services</h2>
            </div>
          </div>
          <div className="flex justify-between flex-col-reverse md:flex-row">
            <div className="w-full md:w-50p  ">
              <p className="text-black text-16 hidden md:block">
                We offer tailor-made strategies for small and medium-sized businesses with PPC advertising services to increase your leads and sales,
                drive traffic to the website and meet the goals of your digital marketing efforts. Continuously delivering PPC marketing services for
                over eight years, we offer highly effective services for the right campaign types to help you achieve significant results. Thus, we
                have developed Search Ads, Display Ads, and Video Ads services to match your requirements with the types of PPC ads. The success of a
                Paid Ads campaign solely depends on the skills of specialists who plan, determine a bid strategy, and optimize the campaign. Being
                Google Partner we are confident in our success regardless of project scale. Depending on your business needs, we will find the most
                effective type based on extensive research and ensure high conversion rates and revenue generation deliverables.{' '}
              </p>
              <div className="block md:hidden">
                <ViewMore ln={20}>
                  We offer tailor-made strategies for small and medium-sized businesses with PPC advertising services to increase your leads and
                  sales, drive traffic to the website and meet the goals of your digital marketing efforts. Continuously delivering PPC marketing
                  services for over eight years, we offer highly effective services for the right campaign types to help you achieve significant
                  results. Thus, we have developed Search Ads, Display Ads, and Video Ads services to match your requirements with the types of PPC
                  ads. The success of a Paid Ads campaign solely depends on the skills of specialists who plan, determine a bid strategy, and optimize
                  the campaign. Being Google Partner we are confident in our success regardless of project scale. Depending on your business needs, we
                  will find the most effective type based on extensive research and ensure high conversion rates and revenue generation deliverables.{' '}
                </ViewMore>
              </div>
            </div>
            <div className="hidden md:block  w-full md:w-40p max-w-380 bg-transparent md:bg-red-smm py-0 md:py-24 px-0 md:px-26 self-start mt-0 md:-mt-70">
              <h2 className={'hidden md:block text-16 md:text-24 leading-29 md:leading-29 tracking-001 text-black font-bolder'}>
                PPC Monthly Services
              </h2>
              <p className="md:flex items-center  mt-15 flex text-purple font-real-bold text-40">
                {paidPr} <span className={'italic text-13 ml-10'}>/ Initial Ad Investment</span>{' '}
              </p>

              <div className="flex mt-0  md:mt-15 font-normal  text-16 leading-20 items-start">
                <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                <span className={'ml-15'}>Guaranteed Leads</span>
              </div>
              <div className="flex mt-5 font-normal  text-16 leading-20 items-start">
                <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                <span className={'ml-15'}>Google & Bing Ads</span>
              </div>
              <div className="flex mt-5 font-normal text-16 leading-20 items-start">
                <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                <span className={'ml-15'}>Google analytics integration & goal tracking</span>
              </div>
              <div className="flex mt-5 font-normal text-16 leading-20 items-start">
                <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                <span className={'ml-15'}>Ad Banners & Copy Creation</span>
              </div>
              <div
                className="mt-15 pb-20 md:pb-0 flex text-green-badge text-20 leading-24 font-medium cursor-pointer items-center"
                onClick={() => {
                  setShowFull(true);
                  setTimeout(() => scrollTo(paidRef), 200);
                }}
              >
                See Full Deliverables
                <p className="jello-horizontal">
                  {' '}
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                  </svg>
                </p>
              </div>
              <div className="flex items-center md:hidden absolute left-0 bg-red-smm w-full h-54">
                <p className="flex px-20  items-center text-purple font-real-bold text-36">
                  {paidPr} <span className={'italic text-13 ml-10'}>/ Monthly Fee</span>{' '}
                </p>
              </div>
              <div className="mt-82 md:mt-23  flex items-center justify-center relative">
                <button
                  onClick={() => {
                    setService('Paid Advertising Services');
                    document.documentElement.style.overflow = 'hidden';
                    setShowOrderModel(true);
                  }}
                  className={
                    'bg-green-badge hover:bg-green-hover inline-block  transition-all transition-400 text-white   px-23 py-5 text-16 rounded-md'
                  }
                >
                  Get a Proposal
                </button>
              </div>
            </div>
          </div>
        </div>
        <Content show={showFull} refProp={paidRef} />
        <div className="block md:hidden">
          <p className="flex px-20  items-center text-purple font-n-800 text-24">
            <span className={'text-18 text-black uppercase font-medium pr-10'}>PRICE</span>
            {paidPr} <span className={'italic font-bold text-15 ml-10'}>/ Initial Ad Investment</span>
          </p>

          <div className="container py-23 pt-10">
            <a
              href={'/paid-advertising-services/order-now?service=Paid Ads Services'}
              className={
                'bg-green-badge text-center hover:bg-green-hover inline-block w-full  transition-all transition-400 text-white   px-23 py-8 text-16 rounded-md'
              }
            >
              Get a Proposal
            </a>
          </div>
        </div>
      </div>
      <LazyLoad height={300} once>
        <div className="bg-gray-light md:bg-gray-light py-30">
          <div className="container">
            <h2 className={'uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none '}>How is our working process?</h2>
            <div className="mt-0 md:mt-30 pt-0 md:pt-0">
              <SimpleSlider
                width={props.width}
                processes={[
                  {
                    index: 1,
                    title: 'Market Research & Competitors’ PPC Strategies analysis',
                    titleMobile: 'Market Research & Competitors’ PPC Strategies analysis',
                    shortened:
                      'Market research at the initial stages of strategy development allows you to reveal the complete image of the business-related industry and market situation. It also helps identify the channels for reaching the target audience. The research stage is supported and incorporated with competitor analysis to uncover their current PPC landscape, target platforms, used keywords, and other significant insights. The further development of an effective PPC strategy will be based on the acquired data through market research and competitor analysis. Regardless of the project complexity, we always start a partnership with these two fundamental stages. We conduct manual research and run advanced software tools (Semrush, SimilarWeb, and MOZ) to acquire precise data that will help obtain a powerful PPC strategy.',
                    text: 'Market research at the initial stages of strategy development allows you to reveal the complete image of the business-related industry and market situation. It also helps identify the channels for reaching the target audience. The research stage is supported and incorporated with competitor analysis to uncover their current PPC landscape, target platforms, used keywords, and other significant insights. The further development of an effective PPC strategy will be based on the acquired data through market research and competitor analysis. Regardless of the project complexity, we always start a partnership with these two fundamental stages. We conduct manual research and run advanced software tools (Semrush, SimilarWeb, and MOZ) to acquire precise data that will help obtain a powerful PPC strategy.',
                  },
                  {
                    index: 2,
                    title: 'Google Analytics and conversion tracking setup',
                    titleMobile: 'Google Analytics and conversion tracking setup',
                    shortened:
                      'Analytics is critical in growing your business, getting more profound insights into visitor data, understanding your customers’ behavior, and setting data-driven goals. To ensure up-to-date data from Google Analytics, we enable conversion tracking with an accurate setup to better understand the campaign performance for further optimization. It is crucial to have precise conversion tracking as the wrong setup will lead to wrong analysis and useless expenses of the ad campaign budget. Our certified analytics specialists with advanced skills handle conversion tracking through Tag Manager or direct tracking setup, ensuring every dollar is spent on purpose to drive visible effectiveness. Correctly configured conversion tracking will increase the ROAS (return on ad spend) by over 60-70%.',
                    text: 'Analytics is critical in growing your business, getting more profound insights into visitor data, understanding your customers’ behavior, and setting data-driven goals. To ensure up-to-date data from Google Analytics, we enable conversion tracking with an accurate setup to better understand the campaign performance for further optimization. It is crucial to have precise conversion tracking as the wrong setup will lead to wrong analysis and useless expenses of the ad campaign budget. Our certified analytics specialists with advanced skills handle conversion tracking through Tag Manager or direct tracking setup, ensuring every dollar is spent on purpose to drive visible effectiveness. Correctly configured conversion tracking will increase the ROAS (return on ad spend) by over 60-70%.',
                  },
                  {
                    index: 3,
                    title: 'Ad campaign creation',
                    titleMobile: 'Ad campaign creation',
                    shortened:
                      'In digital marketing, if you try to sell to everyone, you will end up selling to no one. That is why it is crucial to match your targeting to your goals and audience, the next stage in launching an ad campaign. In the third step of our collaboration, we provide audience targeting and develop ad campaigns aligned with the business objectives, ensuring 100% success of the campaign. The successful launch of the campaign marks the beginning of the strategy implementation process. Immediately after launch, the ad campaign generates tangible results visible to stakeholders.',
                    text: 'In digital marketing, if you try to sell to everyone, you will end up selling to no one. That is why it is crucial to match your targeting to your goals and audience, the next stage in launching an ad campaign. In the third step of our collaboration, we provide audience targeting and develop ad campaigns aligned with the business objectives, ensuring 100% success of the campaign. The successful launch of the campaign marks the beginning of the strategy implementation process. Immediately after launch, the ad campaign generates tangible results visible to stakeholders.',
                  },
                  {
                    index: 4,
                    title: 'Keyword targeting ',
                    titleMobile: 'Keyword targeting',
                    shortened:
                      'The success of the whole campaign depends on keyword targeting and further optimization. Often ad campaigns fail when prioritizing keyword targeting and neglecting the importance of monitoring, tracking, and optimizing keywords throughout the active ad campaign. As a result, the business will face inefficient campaigns and useless waste. We conduct daily keyword optimization throughout the partnership, ensuring high conversion rates. This optimization process also includes the analysis of negative keywords that are no less critical and may spend a significant part of the ad campaign budget. As an advanced agency, our goal is to control and track negative keywords by eliminating over 65% of useless expenses on negative keywords. To identify target keywords and reveal the negative ones, we use Google Analytics and ensure tangible results.',
                    text: 'The success of the whole campaign depends on keyword targeting and further optimization. Often ad campaigns fail when prioritizing keyword targeting and neglecting the importance of monitoring, tracking, and optimizing keywords throughout the active ad campaign. As a result, the business will face inefficient campaigns and useless waste. We conduct daily keyword optimization throughout the partnership, ensuring high conversion rates. This optimization process also includes the analysis of negative keywords that are no less critical and may spend a significant part of the ad campaign budget. As an advanced agency, our goal is to control and track negative keywords by eliminating over 65% of useless expenses on negative keywords. To identify target keywords and reveal the negative ones, we use Google Analytics and ensure tangible results.',
                  },
                  {
                    index: 5,
                    title: 'Bids optimizations with strategic management ',
                    titleMobile: 'Bids optimizations with strategic management',
                    shortened:
                      'Bid optimization is the most challenging part of paid advertising management, requiring extensive background and experience working with bids, up-to-date knowledge in Google Ads, analytic skills, and detailed testing. Disorganized and inefficient bid optimization results in wasted budget and loss of potential leads. As for our strategy, we implement a smart bid management system after handling all prior stages to save the budget on bidding. Depending on the campaign specifics, we may adapt Manual, smart Target CPA bidding, and more having pre-set tactics for each type of bidding to ensure high conversions at low rates for ads.',
                    text: 'Bid optimization is the most challenging part of paid advertising management, requiring extensive background and experience working with bids, up-to-date knowledge in Google Ads, analytic skills, and detailed testing. Disorganized and inefficient bid optimization results in wasted budget and loss of potential leads. As for our strategy, we implement a smart bid management system after handling all prior stages to save the budget on bidding. Depending on the campaign specifics, we may adapt Manual, smart Target CPA bidding, and more having pre-set tactics for each type of bidding to ensure high conversions at low rates for ads.',
                  },
                  {
                    index: 6,
                    title: 'Remarketing',
                    titleMobile: 'Remarketing',
                    shortened:
                      'After acquiring certain traffic from the campaign, we utilize remarketing. Using this technique, you can target users who have already visited your site and remind them about it. Most companies may fail remarketing campaigns, not having a robust marketing background.  In this phase, our marketing team develops marketing messages that engage visitors and encourage them to continue their buyer journey. It is a unique form of interaction that “reminds” your customers to take action by moving them to the next stage of the buyer’s journey. Supporting ad campaigns, various remarketing strategies focus on converting each interaction and increasing the acquisition rates by 60%-70%.',
                    text: 'After acquiring certain traffic from the campaign, we utilize remarketing. Using this technique, you can target users who have already visited your site and remind them about it. Most companies may fail remarketing campaigns, not having a robust marketing background.  In this phase, our marketing team develops marketing messages that engage visitors and encourage them to continue their buyer journey. It is a unique form of interaction that “reminds” your customers to take action by moving them to the next stage of the buyer’s journey. Supporting ad campaigns, various remarketing strategies focus on converting each interaction and increasing the acquisition rates by 60%-70%.',
                  },
                  {
                    index: 7,
                    title: 'A/B testing to maximize campaign performance',
                    titleMobile: 'A/B testing to maximize campaign performance',
                    shortened:
                      'Rather than relying on guesses or assumptions, we run A/B testing to gather critical data about the campaign and improve performance. Taking the role and influence of A/B testing on ad campaign success critically, we don’t run a campaign and wait for results. Even if our campaign generates conversions and the results meet KPIs, we regularly implement A/B testings as a significant part of the PPC process to maximize performance. We run A/B testing for ad targeting, ad creatives, and advertising types to improve strategy and results.',
                    text: 'Rather than relying on guesses or assumptions, we run A/B testing to gather critical data about the campaign and improve performance. Taking the role and influence of A/B testing on ad campaign success critically, we don’t run a campaign and wait for results. Even if our campaign generates conversions and the results meet KPIs, we regularly implement A/B testings as a significant part of the PPC process to maximize performance. We run A/B testing for ad targeting, ad creatives, and advertising types to improve strategy and results.',
                  },
                  {
                    index: 8,
                    title: 'ROI reporting',
                    titleMobile: 'ROI reporting',
                    shortened:
                      'The final stage in the ad campaign is regular reporting. We provide transparent ROI reporting as part of our effort to build and maintain mutual trust. In this way, we keep partners engaged in the whole process, outlining the strategy, performance, optimizations, and ad campaign results. Moving forward, we stay in touch with partners to discuss the current strategy and point out low-performance tactics to further eliminate or improve them. As part of our monthly calls, our account manager presents the results in non-professional language to engage stakeholders in the process and discuss possible adjustments for the following month.',
                    text: 'The final stage in the ad campaign is regular reporting. We provide transparent ROI reporting as part of our effort to build and maintain mutual trust. In this way, we keep partners engaged in the whole process, outlining the strategy, performance, optimizations, and ad campaign results. Moving forward, we stay in touch with partners to discuss the current strategy and point out low-performance tactics to further eliminate or improve them. As part of our monthly calls, our account manager presents the results in non-professional language to engage stakeholders in the process and discuss possible adjustments for the following month.',
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={300} once>
        <div className="mg-gray-light md:bg-white bg-grid py-30">
          <div className="container">
            <div className="flex flex-wrap flex-col md:flex-row justify-center items-center">
              <p className="text-24 font-medium text-center text-black block md:hidden">Answer a few questions and get a custom proposal</p>
              <img alt="peronage" src="https://admin.weprodigi.com/uploads/files/shares/ppc/proposal3.webp" width={225} height={225} />
              <div className="ml-0 md:ml-100 max-w-500">
                <p className="text-24 font-medium text-black hidden md:block">Answer a few questions and get a custom proposal</p>
                <form className="mt-10 flex flex-col md:flex-row justify-start items-center">
                  <input
                    className="border-purple focus:placeholder-transparent rounded-5 border-1 px-20 py-8"
                    id={'web2'}
                    type="text"
                    name="website"
                    placeholder="Enter your website"
                    onChange={e => setWebsite(e.target.value)}
                  />
                  <a
                    className="ml-0 md:ml-20 bg-purple hover:bg-green hidden md:flex items-center  text-white px-20 py-5 md:py-8 rounded-5 mt-20 md:mt-0 cursor-pointer"
                    onClick={() => {
                      setService('Paid Advertising Services');
                      document.documentElement.style.overflow = 'hidden';
                      setShowOrderModel(true);
                    }}
                  >
                    Send Me A Proposal
                  </a>
                  <a
                    className="ml-0 md:ml-20 bg-purple hover:bg-green flex md:hidden items-center  text-white px-20 py-8 md:py-5 rounded-5 mt-20 md:mt-0 cursor-pointer"
                    href={'/paid-advertising-services/order-now?service=Paid Ads Services&website=' + website}
                  >
                    Send Me A Proposal
                  </a>
                </form>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={300} once>
        <div className="bg-gray-light bg-revenue">
          <div className="relative container">
            <style global jsx>
              {`
                .bg-revenue {
                  background: linear-gradient(to right, #670f7a 30%, #f5f5f5 0%);
                }
                .z-12 {
                  z-index: 12;
                }
                .help-part svg {
                  width: 24px !important;
                  height: 24px !important;
                }
                @media screen and (max-width: 768px) {
                  .bg-revenue {
                    background: #f5f5f5;
                  }
                  .bg-revenue > .container {
                    padding: 0;
                  }
                }
                @media screen and (max-width: 1280px) {
                  .help-part {
                    flex-direction: column;
                  }
                  .help-part > div {
                    width: 100%;
                  }
                  .md\:-right-150 {
                    right: 0;
                  }
                  .texts {
                    margin: 0;
                    padding: 15px;
                    width: 100%;
                  }
                }
                .h-tranisiton {
                  transition: height 1s;
                }
              `}
            </style>
            <div className="hidden md:flex flex-col md:flex-row  min-h-500 md:min-h-700  h-tranisiton">
              <div className="bg-fixed fix-elem  w-full  md:w-25p bg-purple h-tranisiton  min-h-500 md:min-h-700 bg-center bg-cover pt-15 md:pt-0   relative">
                <div className="  absolute z-100 top-90  md:top-100 animationBehance z-12">
                  <div className="text-24 md:text-36 font-black text-green leading-none  uppercase">
                    Why are we{' '}
                    <span className="text-white uppercase">
                      one of the
                      <br /> best PPC <br /> Service
                      <br /> Providers
                    </span>
                  </div>
                </div>
                <div className={'absolute left-0 md:left-0 bottom-0 z-50'}>
                  <img className="hidden md:block" src="https://admin.weprodigi.com/uploads/files/shares/ppc/revenue21.png" alt={'revenue'} />
                  <img
                    className="block  md:hidden ml-auto"
                    src="https://admin.weprodigi.com/uploads/files/shares/ppc/revenueMobile.png"
                    alt={'revenue mobile'}
                  />
                </div>
              </div>
              <div className="w-full md:w-75p">
                <div className="w-full texts container  py-30 md:py-30  h-auto flex flex-col justify-start md:justify-center items-start md:items-center  ml-30 md:ml-0 mt-30 md:mt-0 ">
                  <div className="w-full mt-10 pl-15 ml:pl-30">
                    <h2 className="text-purple font-bolder text-16 ">Dedicated account manager</h2>
                    <div className="text-16 text-black">
                      <ViewMore ln={50}>
                        Your personal account manager will act as the direct link to ensure your requirements are accurately fulfilled. We add a
                        personal touch to relationships and assure you that we stand behind our promises. This relationship means we are respectful,
                        professional, and caring. Your account manager will be in touch throughout the project, presenting optimization details, the
                        results of ad investment, and any significant and insignificant aspects related to the project. Every conversion is shared
                        with you as a success that eventually leads to revenue growth.
                      </ViewMore>
                    </div>
                  </div>
                  <div className="w-full mt-10 pl-15 ml:pl-30">
                    <h2 className="text-purple font-bolder text-16 ">Clearly defined deliverables & ad budget management</h2>
                    <div className="text-16 text-black">
                      <ViewMore ln={43}>
                        To build a trusted partnership, we offer absolute transparency for deliverables and ad budget management, thus making you an
                        integral part of the process. Within the project scope, we will share documented marketing strategies and analytics in report
                        form, ad budget planning, management, and reporting. The ongoing tracking and reporting will help you measure the results of
                        ad campaigns at any stage.
                      </ViewMore>
                    </div>
                  </div>
                  <div className="w-full mt-10 pl-15 ml:pl-30">
                    <h2 className="text-purple font-bolder text-16 ">Happy team = happy clients</h2>
                    <div className="text-16 text-black">
                      <ViewMore ln={50}>
                        Your success is our goal, and our success is your fulfilled goal. The circle that is smoothly spinning around is based on our
                        dedication, hard work, and your trust. From the very moment of partnership to the fulfillment of your business requirements,
                        our team will contribute time and effort to delivering tangible results.
                      </ViewMore>
                    </div>
                  </div>
                  <div className="w-full mt-10 pl-15 ml:pl-30">
                    <h2 className="text-purple font-bolder text-16 ">Saved time</h2>
                    <div className="text-16 text-black">
                      <ViewMore ln={50}>
                        We take your time as the most valuable asset and use all the levers of influence to use it optimally and efficiently.
                        Developing tailor-made projects for each partner, we still manage to introduce ad campaigns in the shortest time. Our
                        professional customer support, available for 24 hours, is ready to address your needs and save time on problem-solving. With
                        Paid ads turned on, every day costs money. Valuing your time and money, we manage all the processes on time with actionable
                        tactics to help you generate expected revenue and more.
                      </ViewMore>
                    </div>
                  </div>
                  <div className="w-full mt-10 pl-15 ml:pl-30">
                    <h2 className="text-purple font-bolder text-16 ">Transparent ROI reporting</h2>
                    <div className="text-16 text-black">
                      <ViewMore ln={50}>
                        Another component of a trusted partnership is transparent reporting that will clearly outline the ad campaign's performance,
                        achieved results, and how far your investments are transformed into conversions and revenue. In short, you will have a
                        transparent reporting for your ROI (return on investment) that will help you understand and measure how much your efforts are
                        paid off at the given time.
                      </ViewMore>
                    </div>
                  </div>
                  <div className="w-full mt-10 pl-15 ml:pl-30">
                    <h2 className="text-purple font-bolder text-16 ">On-staff experts in marketing, design, automation & development</h2>
                    <div className="text-16 text-black">
                      <ViewMore ln={50}>
                        We are proud to call ourselves a multi-dimensional team of experts not afraid of dealing with complex tasks. Our expertise
                        covers all the aspects of marketing, design, automation, and development. Once handling your leads, we are ready to guide them
                        through the powerful marketing funnel, convert them into happy customers & generate revenue for your business.
                      </ViewMore>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex md:hidden flex-col md:flex-row help-part mobile">
              <div className="container absolute  top-90 md:top-100 animationBehance z-12">
                <div className="text-24 md:text-36  font-black text-green leading-22 md:leading-none  uppercase">
                  Why are we <br />
                  <span className="text-white uppercase">
                    one of the
                    <br /> best PPC <br /> Service
                    <br /> Providers
                  </span>
                </div>
              </div>
              <div className="bg-fixed fix-elem  w-full  md:w-30p bg-purple bg-center bg-cover pt-15 md:pt-0  min-h-500 md:min-h-900  relative">
                <div className={'absolute right-0 md:-right-0 bottom-0 z-50'}>
                  <img className="hidden md:block" src="https://admin.weprodigi.com/uploads/files/shares/ppc/revenue21.png" alt={'revenue'} />
                  <img
                    className="block  md:hidden ml-auto"
                    src="https://admin.weprodigi.com/uploads/files/shares/ppc/revenueMobile.png"
                    alt={'revenue mobile'}
                  />
                </div>
              </div>
              <div className="w-full texts  py-30 md:py-30  md:w-70p h-auto flex flex-col justify-start md:justify-center items-start md:items-center  ml-30 md:ml-0 mt-30 md:mt-0 ">
                <Includings
                  content={[
                    {
                      title: 'Dedicated account manager',
                      answer:
                        'Your personal account manager will act as the direct link to ensure your requirements are accurately fulfilled. We add a personal touch to relationships and assure you that we stand behind our promises. This relationship means we are respectful, professional, and caring. Your account manager will be in touch throughout the project, presenting optimization details, the results of ad investment, and any significant and insignificant aspects related to the project. Every conversion is shared with you as a success that eventually leads to revenue growth.',
                    },
                    {
                      title: 'Clearly defined deliverables & ad budget management ',
                      answer:
                        'To build a trusted partnership, we offer absolute transparency for deliverables and ad budget management, thus making you an integral part of the process. Within the project scope, we will share documented marketing strategies and analytics in report form, ad budget planning, management, and reporting. The ongoing tracking and reporting will help you measure the results of ad campaigns at any stage.',
                    },
                    {
                      title: 'Happy team = happy clients',
                      answer:
                        'Your success is our goal, and our success is your fulfilled goal. The circle that is smoothly spinning around is based on our dedication, hard work, and your trust. From the very moment of partnership to the fulfillment of your business requirements, our team will contribute time and effort to delivering tangible results.',
                    },
                    {
                      title: 'Saved time',
                      answer:
                        'We take your time as the most valuable asset and use all the levers of influence to use it optimally and efficiently. Developing tailor-made projects for each partner, we still manage to introduce ad campaigns in the shortest time. Our professional customer support, available for 24 hours, is ready to address your needs and save time on problem-solving. With Paid ads turned on, every day costs money. Valuing your time and money, we manage all the processes on time with actionable tactics to help you generate expected revenue and more.',
                    },
                    {
                      title: 'Transparent ROI reporting',
                      answer:
                        'Another component of a trusted partnership is transparent reporting that will clearly outline the ad campaign’s performance, achieved results, and how far your investments are transformed into conversions and revenue. In short, you will have a transparent reporting for your ROI (return on investment) that will help you understand and measure how much your efforts are paid off at the given time.',
                    },
                    {
                      title: 'On-staff experts in marketing, design, automation & development',
                      answer:
                        'We are proud to call ourselves a multi-dimensional team of experts not afraid of dealing with complex tasks. Our expertise covers all the aspects of marketing, design, automation, and development. Once handling your leads, we are ready to guide them through the powerful marketing funnel, convert them into happy customers & generate revenue for your business.',
                    },
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={300} once>
        <div className={`bg-white`}>
          <div className={`image-left-block py-30 container`}>
            <h2 className={'text-purple text-24 md:text-36 font-black uppercase '}>WE ARE PAID ADS SUPERHEROS</h2>
            <div className="flex flex-wrap-reverse">
              <div className="w-full md:w-50p mt-30">
                <picture>
                  <source media="(min-width:768px)" srcSet="/images/team/PM-group_images.png" type="image/png" />
                  <source media="(max-width:768px)" srcSet="/images/team/PM-group_images.png" type="image/png" />
                  <img className="mx-auto md:mx-0" src="" width={539} height={303} alt="pmGroup" />
                </picture>
              </div>
              <div className="w-full md:w-50p mt-20 md:mt-30 pl-0 md:pl-30">
                Armed with superpowers in Paid Advertising and digital solutions to make your brand rock, we will become your superheroes. Let’s get
                acquainted. Mariam, PPC specialist or Search Ads Hero, in short fights negative keywords and converts time into revenue before you can
                even blink. As a PPC expert, Maria handles analytic skills, creates tracking systems, and efficiently optimizes ads with a true
                genius’ mind, constantly keeping her eye on data. Valera, Captain Video Ads Specialist, his superpower is reading users’ minds to
                understand whether the video will go viral or not. He can increase your view rates and take up your KPIs to the universe with his
                talent. Rosie, Digital Marketing Strategist, is a master targeter with keen eyesight to reveal the right audience and create targeted
                conversions. Our super squad working hand in hand will craft a machine to boost conversions, increase revenue and promote brand
                reputation.
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={300} once>
        <div className="bg-gray-light">
          <div className=" container py-30">
            <h2 className="text-purple text-24 md:text-36 uppercase font-black mb-20 leading-none">OUR CLIENTS' EXPERIENCE </h2>
            <VideoReviewsSlider
              from={'ppc'}
              reviews={[
                {
                  video: 'https://admin.weprodigi.com/uploads/files/shares/ppc/rev.mp4',
                  thumbnail: 'https://admin.weprodigi.com/uploads/files/shares/ppc/Screenshot_1.png',
                  logo: 'https://admin.weprodigi.com/uploads/files/shares/ppc/healthline.svg',
                  position: 'Marketing Director |',
                  custommerName: 'Michael Holland',
                  flag: 'https://admin.weprodigi.com/uploads/files/shares/ppc/Flag_of_Canada_(Pantone).svg',
                  index: 1,
                },
                {
                  video: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/ZackFinal1.mp4',
                  thumbnail: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/zach.png',
                  logo: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/Vuit-logo2.png',
                  position: 'Founder |',
                  custommerName: 'Zach Marinello',
                  flag: 'https://admin.weprodigi.com/uploads/files/shares/ppc/uk.svg',
                  index: 2,
                },
                {
                  video: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/DianaFinal.mp4',
                  thumbnail: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/diana.png',
                  logo: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/Logo-Animation01.png',
                  position: 'Head of Marketing Department |',
                  custommerName: 'Diana Gaeta',
                  flag: 'https://admin.weprodigi.com/uploads/files/shares/ppc/us.svg',
                  index: 3,
                },
              ]}
            />
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={300} once>
        <div className={`bg-white`}>
          <div className={`image-left-block py-30 container`}>
            <h2 className={'text-purple text-24 md:text-36 font-black uppercase'}>PPC MANAGEMENT SERVICE CASE STUDIES</h2>
            <PPCManagementSLider slides={ppc} currency={props.currency} />
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={300} once>
        <div className={`bg-gray-light`}>
          <div className={`image-left-block py-30 container`}>
            <h2 className={'text-purple text-24 md:text-36 font-black uppercase'}>Your project is in trusted hands</h2>
            <div className="mt-15 flex flex-wrap justify-between md:justify-between items-start">
              <div className="max-w-100p  md:max-w-250 w-full mt-15 flex md:block  items-center">
                <a className={'w-150 md:w-auto'} href="https://www.google.com/partners/agency?id=2472484045" target={'_blank'}>
                  <img className="mb-0 mr-5" alt="partner" src="https://admin.weprodigi.com/uploads/files/shares/ppc/Partner-RGB-.svg" width={80} />
                </a>
                <ViewMorePPC ln={15} from="ppc">
                  This certificate badge shows that we are Google’s official partners, we have appropriate benefits like their reward program,
                  exclusive webinars, etc.
                </ViewMorePPC>
              </div>
              <div className="max-w-100p  md:max-w-250 w-full mt-20 md:mt-15 flex md:block  items-center">
                <a
                  className={'w-150 md:w-auto'}
                  href="https://www.credly.com/badges/5a49bdca-665c-4087-9428-37cad0ec1938/public_url"
                  target={'_blank'}
                >
                  <img alt="partner" className="mb-23 mr-5" src="https://admin.weprodigi.com/uploads/files/shares/ppc/blueprint.svg" width={80} />
                </a>
                <ViewMorePPC ln={16} from="ppc">
                  This credential is awarded to our digital marketers who have proficiency in the skills, tools, advertising policies, and best
                  practices required to buy ads on the Facebook App, Instagram, and Messenger.
                </ViewMorePPC>
              </div>
              <div className="max-w-100p  md:max-w-250 w-full mt-20 md:mt-15 flex md:block  items-center  ">
                <a
                  className={'w-150 md:w-auto'}
                  href="https://weprodigi.com/uploads/files/shares/certificates/Course_Certificate.pdf"
                  target={'_blank'}
                >
                  <img alt="partner" className="mb-16 mr-5" src="https://admin.weprodigi.com/uploads/files/shares/ppc/analitics.svg" width={80} />
                </a>
                <ViewMorePPC ln={16} from="ppc">
                  This certificate shows that our team is fluent in analytics and processing data to gain key business insights.
                </ViewMorePPC>
              </div>
              <div className="max-w-100p  md:max-w-250 w-full mt-20 md:mt-15 flex md:block  items-center ">
                <a className={'w-150 md:w-auto'} href="#" target={'_blank'}>
                  <img alt="partner" className="mb-25 mr-5" src="https://admin.weprodigi.com/uploads/files/shares/ppc/bing.svg" width={80} />
                </a>
                <ViewMorePPC ln={16} from="ppc">
                  This badge shows that we’re pros in the advertising platform to help you maximize budget and results when running ads on the
                  Microsoft network.
                </ViewMorePPC>
              </div>
              <div className="max-w-100p  md:max-w-250 w-full mt-20 md:mt-15 flex md:block  items-center">
                <a className={'w-150 md:w-auto'} href="https://weprodigi.com/uploads/files/shares/certificates/hubspot.png?" target={'_blank'}>
                  <img alt="partner" className="mb-15 mr-5" src="https://admin.weprodigi.com/uploads/files/shares/ppc/hubspot.svg" width={80} />
                </a>
                <ViewMorePPC ln={11} from="ppc">
                  This badge includes certificates for Email Marketing, Inbound Sales, Social Media, Inbound Marketing, and Content Marketing which
                  will help us reach your target audience, strengthen the customer relationship, and help your business grow.
                </ViewMorePPC>
              </div>
              <div className="max-w-100p  md:max-w-250 w-full mt-20 md:mt-15 flex md:block  items-center">
                <a className={'w-150 md:w-auto'} href="https://weprodigi.com/uploads/files/shares/certificates/hootsuite.jpg" target={'_blank'}>
                  <img alt="partner" className="mb-22 mr-5" src="https://admin.weprodigi.com/uploads/files/shares/ppc/g833.svg" width={80} />
                </a>
                <ViewMorePPC ln={13} from="ppc">
                  This certificate demonstrates our knowledge of the core principles and strategy behind social media marketing, boosting the impact
                  of your social media efforts, driving results, and proving your ROI.
                </ViewMorePPC>
              </div>
              <div className="max-w-100p  md:max-w-250 w-full mt-20 md:mt-15 flex md:block  items-center">
                <a className={'w-150 md:w-auto'} href="https://weprodigi.com/uploads/files/shares/certificates/oglivy.jpg" target={'_blank'}>
                  <img alt="partner" className="mb-8 mr-5" src="https://admin.weprodigi.com/uploads/files/shares/ppc/oglivy.svg" width={80} />
                </a>
                <ViewMorePPC ln={15} from="ppc">
                  This badge shows that we’re experts in growth & innovation, advertising, we experience work fluidly, problems and obstacles are
                  obvious to us.
                </ViewMorePPC>
              </div>
              <div className="max-w-100p  md:max-w-250 w-full mt-20 md:mt-15 flex md:block  items-center">
                <a
                  className={'w-150 md:w-auto'}
                  href="https://weprodigi.com/uploads/files/shares/certificates/vanes-lion-lilit.jpg"
                  target={'_blank'}
                >
                  <img alt="partner" className="mb-5 " src="https://admin.weprodigi.com/uploads/files/shares/ppc/lions.svg" width={80} />
                </a>
                <ViewMorePPC ln={12}>
                  This puts us among the global creative staff, from research to objectives, KPIs, customer journeys, briefings, evaluations, etc.
                </ViewMorePPC>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={300} once>
        <style>{`
                        @media screen and (max-width:768px){
                            .custom-plan{
                             background-image: url("https://admin.weprodigi.com/uploads/files/shares/ppc/budget_plan_mobile2.png")!important;
                            z
                            }
                        }
                        .btn {
                             
                              position: relative;  
                              box-shadow: -1px 1px 8px rgba(0, 0, 0, 0.4);
                              appearance: none;
                              cursor: pointer;
                              transition: background 250ms, box-shadow 250ms;
                          }
                        .btn .dot {
                          position: absolute;
                          z-index: -1;
                          display: block;
                          width: 200px;
                          height: 10px;
                          transform-origin: 5px 5px;
                          pointer-events: none;
                          z-index:150
                        }
                        .btn .dot:nth-child(1) {
                          top: 50%;
                          left: 100%;
                          transform: translate3d(-10px, -5px, 0);
                        }
                        .btn .dot:nth-child(2) {
                          bottom: 0;
                          left: 100%;
                          transform: translate3d(-10px, 0, 0) rotate(45deg);
                        }
                        .btn .dot:nth-child(3) {
                          bottom: 0;
                          left: 50%;
                          transform: translate3d(-5px, 0, 0) rotate(90deg);
                        }
                        .btn .dot:nth-child(4) {
                          bottom: 0;
                          left: 0;
                          transform: rotate(135deg);
                        }
                        .btn .dot:nth-child(5) {
                          top: 50%;
                          left: 0;
                          transform: translate3d(0, -5px, 0) rotate(180deg);
                        }
                        .btn .dot:nth-child(6) {
                          top: 0;
                          left: 0;
                          transform: rotate(225deg);
                        }
                        .btn .dot:nth-child(7) {
                          top: 0;
                          left: 50%;
                          transform: translate3d(-5px, 0, 0) rotate(270deg);
                        }
                        .btn .dot:nth-child(8) {
                          top: 0;
                          left: 100%;
                          transform: translate3d(-10px, 0, 0) rotate(315deg);
                        }
                        .btn .dot::before {
                          position: absolute;
                          top: 0;
                          left: 0;
                          display: block;
                          width: 8px;
                          height: 8px;
                          background-color: #8DC63F;
                          border-radius: 50%;
                          offset-path: path("M0 1c7.1 0 10.7 2 14.3 4s7.1 4 14.3 4 10.7-2 14.3-4 7.2-4 14.3-4 10.7 2 14.3 4 7.1 4 14.3 4 10.7-2 14.3-4 7.1-4 14.3-4 10.7 2 14.3 4 7.1 4 14.3 4 10.7-2 14.3-4 7.1-4 14.3-4 10.7 2 14.3 4 7.1 4 14.3 4");
                          offset-distance: 0;
                          pointer-events: none;
                          content: "";
                        }
                        
                        .btn.is-animating .dot::before {
                          -webkit-animation: dot 1750ms cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
                                  animation: dot 1750ms cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
                        }
                        @-webkit-keyframes dot {
                          0% {
                            offset-distance: 0%;
                            opacity: 1;
                          }
                          100% {
                            offset-distance: 100%;
                            opacity: 0;
                          }
                        }
                        @keyframes dot {
                          0% {
                            offset-distance: 0%;
                            opacity: 1;
                          }
                          100% {
                            offset-distance: 100%;
                            opacity: 0;
                          }
                        }
                    `}</style>
        <div
          className={`bg-cover custom-plan h-272 md:h-160`}
          style={{ backgroundImage: `url(https://admin.weprodigi.com/uploads/files/shares/ppc/budget_plan.png)` }}
        >
          <div className={`image-left-block overflow-hidden flex flex-col justify-center container text-center  h-272 md:h-160`}>
            <h3 className={'text-white text-24 md:text-36 font-bolder md:font-black uppercase z-200'}>Custom Budget Plan for your business</h3>
            <div className={'w-full flex justify-center text-center overflow-hidden py-20'}>
              <button
                className="is-animating self-center btn hidden md:block text-white bg-green hover:bg-white hover:text-purple hover:font-bolder shadow-md shadow-white  py-8   px-23 52 rounded-5  "
                onClick={() => {
                  setService('Paid Advertising Services');
                  setShowOrderModel(true);
                  document.documentElement.style.overflow = 'hidden';
                }}
              >
                <span>Request Now</span>
                <span className="dot" />
                <span className="dot" />
                <span className="dot" />
                <span className="dot" />
                <span className="dot" />
                <span className="dot" />
                <span className="dot" />
                <span className="dot" />
              </button>
            </div>
            <div className={'w-full  justify-center text-center  overflow-hidden py-20 flex md:hidden'}>
              <a
                className="is-animating btn self-center block md:hidden text-white bg-green px-23 py-5 shadow-md shadow-white rounded-5 mt-15"
                href={'/paid-advertising-services/get-proposal'}
              >
                <span> Request Now</span>
                <span className="dot" />
                <span className="dot" />
                <span className="dot" />
                <span className="dot" />
                <span className="dot" />
                <span className="dot" />
                <span className="dot" />
                <span className="dot" />
              </a>
            </div>
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={300} once>
        <div className={`bg-gray-light`}>
          <div className={`image-left-block py-30 container`}>
            <h2 className={'text-purple text-24 md:text-36 font-black uppercase'}>
              Why should you include Paid Ads services <br />
              in your marketing plan?
            </h2>
            <div className="flex flex-wrap-reverse">
              <div className="w-full md:w-50p mt-30">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/search4.png" width={589} height={600} alt="search" />
              </div>
              <div className="w-full md:w-50p mt-10 md:mt-30 pl-0 md:pl-30">
                <div className="w-full mt-10 pl-0 md:pl-15">
                  <h2 className="text-purple font-bolder text-16 ">Immediate results</h2>
                  <p className="text-16 text-black">
                    Running through all possible ad platforms, you can track and measure performance results and rate the campaign productivity
                    immediately after launching an ad campaign.
                  </p>
                </div>
                <div className="w-full mt-10 pl-0 md:pl-15">
                  <h2 className="text-purple font-bolder text-16 ">It is hyper-targeted</h2>
                  <p className="text-16 text-black">
                    Ads may not show up at the ideal time, but PPC advertising has revolutionized the reach-out strategies. Being hyper-targeted
                    allows segmenting a specific audience by demographics, custom intent, content keywords, and running your ad more efficiently.
                  </p>
                </div>
                <div className="w-full mt-10 pl-0 md:pl-15">
                  <h2 className="text-purple font-bolder text-16 ">Control your budget</h2>
                  <p className="text-16 text-black">
                    By implementing a strategic approach to conversion-based smart bidding that meets your company goals, it is possible to run a
                    cost-effective and simultaneously successful ad campaign.
                  </p>
                </div>
                <div className="w-full mt-10 pl-0 md:pl-15">
                  <h2 className="text-purple font-bolder text-16 ">An easy way to convert</h2>
                  <p className="text-16 text-black">
                    Unlike other marketing tactics, PPC ads control the target audience's actions and desires, thus promoting products on the go. Each
                    click takes your cold customer through a conversion funnel transforming into a warm lead and ending with potential customers on
                    your landing page.
                  </p>
                </div>
                <div className="w-full mt-10 pl-0 md:pl-15">
                  <h2 className="text-purple font-bolder text-16 ">Controlling and optimizing ads</h2>
                  <p className="text-16 text-black">
                    Aside from default settings, PPC advertising can and should be constantly controlled and optimized based on up-to-date data to
                    deliver higher efficiency.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={300} once>
        <style jsx global>{`
          .after-element::after {
            content: '';
            position: absolute;
            width: 63%;
            height: 100%;
            top: 0;
            right: -118px;
            transform: skewX(-31deg);
            background: rgba(103, 15, 122, 0.69);
          }
          @media screen and (max-width: 1024px) {
            .after-element::after {
              width: 100%;
              right: -258px;
            }
          }
          @media screen and (max-width: 768px) {
            .mobileAudit {
              background-image: url('https://admin.weprodigi.com/uploads/files/shares/ppc/audit_mobile2.png') !important;
            }
          }
          .z-15 {
            z-index: 15;
          }
        `}</style>
        <div
          className={`relative bg-cover after-element min-h-250 overflow-hidden	mobileAudit`}
          style={{ backgroundImage: `url(https://admin.weprodigi.com/uploads/files/shares/ppc/audit.png)` }}
        >
          <div className={`image-left-block py-30 container flex flex-wrap md:flex-nowrap relative z-15`}>
            <div className="max-w-400 w-full text-white uppercase font-black text-36">
              Already have run paid ads campaign, but not happy with results?
            </div>
            <div className="ml-0 md:ml-100">
              <h2 className="text-24 font-bold mt-20 text-white ml-10">FREE PPC AUDIT</h2>
              <form onSubmit={onSubmit}>
                <div className="flex flex-wrap md:flex-nowrap">
                  <div className="flex flex-col m-10 w-full md:w-auto">
                    <label htmlFor="name" className="text-white capitalize">
                      name*
                    </label>
                    <input
                      type="text"
                      required={true}
                      className="bg-white rounded-5 px-20 py-5 outline-none mt-5 w-full max-w-500 md:max-w-160"
                      id="name"
                      name="name"
                      onChange={e => setName(e.target.value)}
                    />
                  </div>
                  <div className="flex flex-col m-10 w-full md:w-auto">
                    <label htmlFor="company_name" className="text-white capitalize">
                      Company Name*
                    </label>
                    <input
                      type="text"
                      required={true}
                      className="bg-white rounded-5 px-20 py-5 outline-none mt-5 w-full max-w-500 md:max-w-160 "
                      id="company_name"
                      name="company_name"
                      onChange={e => setCompanyName(e.target.value)}
                    />
                  </div>
                  <div className="flex flex-col m-10 mr-0 w-full md:w-auto">
                    <label htmlFor="website" className="text-white capitalize">
                      Website*
                    </label>
                    <input
                      type="text"
                      required={true}
                      className="bg-white rounded-5 px-20 py-5 outline-none mt-5 w-full max-w-500 md:max-w-160"
                      id="website"
                      name="website"
                      onChange={e => setWebsite2(e.target.value)}
                    />
                  </div>
                </div>
                <div className="flex flex-wrap md:flex-nowrap w-full md:w-auto justify-between">
                  <div className="flex flex-col m-10 mr-0 w-full ">
                    <label htmlFor="email" className="text-white capitalize">
                      E-mail*
                    </label>
                    <input
                      type="email"
                      required={true}
                      className="bg-white rounded-5 px-20 py-5 outline-none mt-5 "
                      id="email"
                      name="email"
                      onChange={e => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="flex flex-col m-10 mr-0 w-full ">
                    <label htmlFor="phone-number" className="text-white capitalize">
                      Phone Number*
                    </label>
                    <input
                      required={true}
                      type="text"
                      className="bg-white rounded-5 px-20 py-5 outline-none mt-5"
                      id="phone-number"
                      name="phone-number"
                      onChange={e => setPhone(e.target.value)}
                    />
                  </div>
                </div>
                <div className="flex flex-wrap md:flex-nowrap w-full md:w-auto justify-end mt-15">
                  <button className="b-none bg-green hover:bg-white hover:text-black text-16 md:text-16 text-white ml-15 shadow-md py-8 px-23 rounded-5">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={300} once>
        <div className="bg-gray-light md:bg-gray-light">
          <div className="container py-23">
            <h3 className="text-24 md:text-36 mb-23 font-black text-purple leading-none">FAQs</h3>
            <div className="grid md:grid-cols-2 md:gap-30">
              <Faq
                content={[
                  {
                    title: 'What type of results can I expect?',
                    answer:
                      "Our goal is to increase conversion rates and “push” users to take actions like filling out a form, leaving contact details, scheduling an appointment, or making a purchase. We will track and analyze each click and the traffic overall through monitoring and analytics tools to assess the campaign's efficiency and bring out the number of converted payable customers.",
                  },
                  {
                    title: 'How long does it take to see results?',
                    answer:
                      'Once the campaign is set up and ready to go, it goes through a review process that takes no more than a day. Once done, the campaign will be live and start driving immediate traffic to your website. The tangible results will be visible straight away. To make your campaign even more effective and successful, we will carry out daily optimizations based on constantly monitored data.',
                  },
                  {
                    title: 'How many conversions can I expect?',
                    answer: (
                      <>
                        The volume of conversions is project-specific and may vary. We will track and measure your conversion rate through analytics.
                        We will gradually improve the campaigns using the performance data from the advertising campaigns. With this in mind, we
                        anticipate that your conversion rate will improve over time. <br /> However, you should always keep in mind that external and
                        less controlled factors may impact conversions. Such factors are product quality, ad destination, website quality, and the
                        market you are competing in.
                      </>
                    ),
                  },
                  {
                    title: 'How long does it take to launch the ad campaign?',
                    answer:
                      'The ad campaign is launched immediately after being approved. On average, the campaigns are going live within five working days. We use this period to research and prepare the material for ad campaigns. ',
                  },
                  {
                    title: 'How will you learn about my business?',
                    answer:
                      'We have a questionnaire that is customized based on your business research. Upon answering the questions, we will learn about your business perspectives, your product or service, business goals, and pain points. We value your time and provide a brief questionnaire with the most important questions left blank after your website research. Upon completion, we will schedule an onboarding call with you to discuss the questionnaire and any additional questions about your business. After the kickoff call, we will research and develop a strategy based on your business objectives.',
                  },
                ]}
                from="ppc"
              />
              <Faq
                content={[
                  {
                    title: 'How will you create ads that fit my business?',
                    answer: (
                      <>
                        You will get a comprehensive answer to your question once you request a custom-free proposal. Our primary focus on the first
                        stages of collaboration is to reveal your business need and build a partnership to cover your needs. The custom strategy
                        developed for you will specify the advertising approach used for your business. We will start building the ad campaigns as
                        soon as you approve this strategy. You will have full access to review all advertisements before they are published.
                      </>
                    ),
                  },
                  {
                    title: 'Do I have to provide you with content for advertisements?',
                    answer:
                      'No, you are free of any kinds of efforts in terms of providing the content. However, if you have content, we are happy to consider it. Your project will be handled by a team of design, production and marketing professionals with extensive expertise in PPC projects։ We have access to premium stock images and videos, design software tools, and relevant news sources.In short, we possess any levers of influence to develop engaging ads.',
                  },
                  {
                    title: 'Will you monitor the ad campaign to ensure we do not waste any money?',
                    answer: (
                      <>
                        Our PPC manager will be daily monitoring your advertising campaigns. If ads are not performing well, we will pause them and
                        improve your campaign. In addition, your PPC manager will regularly optimize your campaign and run A/B split tests in your ad
                        campaign (this is the process of testing multiple variations of your ads and the audiences for the ads). By testing different
                        combinations of ads, we are more likely to identify compelling performances.
                      </>
                    ),
                  },
                  {
                    title: 'How much does a PPC ad campaign cost?',
                    answer: (
                      <>
                        On average, small-to-midsized businesses will spend $2000 to $10,000 per month on PPC. Costs include ad expenses and the cost
                        of management services.
                      </>
                    ),
                  },
                  {
                    title: 'Can I pay directly to ad platforms?',
                    answer: (
                      <>
                        Yes, of course. In these terms of the partnership, you will pay us the management fee solely, add your credit card to the ad
                        account, and the advertising platforms will automatically withdraw ad expenses.
                      </>
                    ),
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={300} once>
        <div className={`bg-white`}>
          <div className=" container py-23">
            <h3 className="text-purple text-30 md:text-36 uppercase font-black mb-23 leading-none">additional MARKETING services</h3>
            <AdditionalPPCSlider />
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={300} once>
        <SchedulaACall
          country={props.country}
          width={props.width}
          url="https://calendar.app.google/uJZkJfztLwHZcfkC7"
        />
      </LazyLoad>

      <GetProposal country={props.country} show={showOfferModal} hide={hideOfferModal} website={website} currency={props.currency} />
      <GetOrderProposal
        website={website}
        country={props.country}
        show={showOrderModel}
        hide={hideOrderModal}
        service={service}
        currency={props.currency}
      />
      <GetCustomProposal
        country={props.country}
        show={showCostumProposalModel}
        hide={hideCostumProposalModal}
        website={website}
        currency={props.currency}
      />
      <Thanks show={showThanks} loaded={loadedThanks} hide={hideThanksModal}>
        Thank you for reaching out to us! One of our account managers will contact you and confirm your request. If you don’t receive an email from us
        within 24 hours please check your Spam Box.
      </Thanks>
    </>
  );
};

export default PaidAdvertiseingServices;
